module.exports = __webpack_public_path__ + "static/ANU_logo_horz-b12c2bb24030ed4f7e83ddce43123827.png";